import { MutationTree, StoreOptions, Module, GetterTree, ActionTree } from 'vuex';
import { VuexState } from '@/interfaces/vuexStateInterface';
import VuexModuleState from '@/interfaces/vuexModuleStateInterface';
import { State } from 'vuex-class';
import i18n from '@/lang/index';

const state = {
  // 题型
  quzTypeMapping: {
    // 【 1:判断题,2:单选题,3:多选题,4:简答题,5:填空题,6:不定项题,7:文件题,10:段落说明】
    1: i18n.t('CommonComponents.SubjectType.判断题'),
    2: i18n.t('CommonComponents.SubjectType.单选题'),
    3: i18n.t('CommonComponents.SubjectType.多选题'),
    4: i18n.t('CommonComponents.SubjectType.简答题'),
    5: i18n.t('CommonComponents.SubjectType.填空题'),
    6: i18n.t('CommonComponents.SubjectType.不定项题'),
    7: i18n.t('CommonComponents.SubjectType.文件题'),
    10: i18n.t('CommonComponents.SubjectType.段落说明'),
    // 新增
    11: i18n.t('CommonComponents.SubjectType.投票单选'),
    12: i18n.t('CommonComponents.SubjectType.投票多选'),
    13: i18n.t('CommonComponents.SubjectType.数值评价题'),
    14: i18n.t('CommonComponents.SubjectType.匿名开放题'),
    15: i18n.t('CommonComponents.SubjectType.拍照题')
  },
  difficultyMapping: {
    // 难易度 试题难度 1：易 2：中 3：难
    1: i18n.t('CommonComponents.difficulty.易'),
    2: i18n.t('CommonComponents.difficulty.中'),
    3: i18n.t('CommonComponents.difficulty.难')
  },
  testingTypeTransMap: { // 将测试的type转换为互动答题的type key: 测试的type, value: 互动答题的type
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '44',
    6: '33',
    7: '77',
    10: '10'
  },
  uploadFileLock: false, // false-可以上报防切屏, true, 不用上报防切屏
};

const getters = {};

const mutations: MutationTree<any> = {
  setReplyType(state, data) {
    state.replyType = data;
  },
  setFinishState: (state, flag) => {
    state.isShowFinishDialog = flag;
  },
  SET_UPLOAD_FILE_LOCK: (state, lockState) =>{
    state.uploadFileLock = lockState
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
